// extracted by mini-css-extract-plugin
export default {"boxGral":"EntregasContainersSt_boxGral__PTZgS","containerEnt":"EntregasContainersSt_containerEnt__9c2Qj"};